<template>
    <div>
      <component :is="getUserRoleCode"></component>
    </div>
</template>

<script>
import adminFirstPage from '../b2cbusiness/AdminFirstPage';
import businessFirstPage from '../businessclient/BusinessFirstPage';
import {getUserInfo} from "../../api/system/sys_user";
import {pwdIsDefault} from '@/api/system/sys_user'
import salesmanFirstPage from "../salemanclient/SalesmanFirstPage";
import FinanceFirstPage from "@/views/b2cbusiness/FinanceFirstPage";
    export default {
      name: "FirstPage",
      data(){
        return {
          userRoleCode: ""
        }
      },
      created:function(){
        pwdIsDefault().then(res => {
          if(res.success && res.data){//表示正在使用默认密码
            this.$confirm("您仍在使用系统初始化密码，建议您去修改", '提示', {
              confirmButtonText: '现在就去',
              cancelButtonText: '以后再说',
              type: 'warning'
            })
            .then(_ => {
              this.$router.push({name:"personal"})
            });
          }
        });
      },
      mounted() {
        getUserInfo().then(res => {
          let userInfo = res.data;
          this.userRoleCode = userInfo.b2cRole.roleCode;
        });
      },
      computed: {
        getUserRoleCode(){
          if (this.userRoleCode == "admin" || this.userRoleCode == "cuservices"
              || this.userRoleCode == "manager" || this.userRoleCode == "ownermanager" || this.userRoleCode == "returnfinance"){
            return adminFirstPage;
          }else if(this.userRoleCode == "finance"){
            return FinanceFirstPage;
          }else if (this.userRoleCode == "business"){
            return businessFirstPage;
          }else if (this.userRoleCode ==  "salesman"){
            return salesmanFirstPage;
          }
        }
      }
    }
</script>

<style scoped>

</style>
